import { colors } from '@/theme/colors';
import { MetaFunction } from 'react-router';

interface BuildPageMetaProps {
  title?: string;
  description?: string;
  themeColor?: string;
  image?: string;
  addNoIndex?: boolean;
  canonicalLink?: string;
}

export const buildPageMeta: (params: BuildPageMetaProps) => ReturnType<MetaFunction> = ({
  title = 'Flexcar: Your flexible car lease. Zero down. Cancel anytime.',
  description,
  themeColor = colors.neutral100,
  image = '/url-preview.png',
  addNoIndex = false,
  canonicalLink,
}) => {
  const titleAttributes: ReturnType<MetaFunction> = [
    { title: title },
    {
      property: 'og:title',
      content: title,
    },
    {
      name: 'twitter:title',
      content: title,
    },
  ];

  const descriptionAttributes: ReturnType<MetaFunction> = !description
    ? []
    : [
        {
          property: 'og:description',
          content: description,
        },
        {
          name: 'description',
          content: description,
        },
      ];

  const defaults: ReturnType<MetaFunction> = [
    // Properties
    { property: 'og:site_name', content: 'Flexcar' },
    { property: 'og:url', content: 'https://www.flexcar.com' },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: image },
    // Names
    {
      name: 'google-site-verification',
      content: 'eMcVxJtQK2O854Bau5BNthlNWPRt6TTD2M9cfZSBEiA',
    },
    { name: 'apple-itunes-app', content: 'app-id=1548544372' },
    {
      name: 'twitter:card',
      content: image !== '/url-preview.png' ? 'summary_large_image' : 'summary',
    },
    { name: 'twitter:site', content: 'https://www.flexcar.com' },
    // Icons
    {
      tagName: 'link',
      rel: 'icon',
      href: '/16x16.png?v=1',
      size: '16x16',
    },
    {
      tagName: 'link',
      rel: 'icon',
      href: '/32x32.png?v=1',
      size: '32x32',
    },
    {
      tagName: 'link',
      rel: 'icon',
      href: '/96x96.png?v=1',
      size: '96x96',
    },
  ];

  const noIndex: ReturnType<MetaFunction> = addNoIndex
    ? [{ name: 'robots', content: 'noindex' }]
    : [];

  const canonicalLinkAttribute: ReturnType<MetaFunction> = canonicalLink
    ? [{ tagName: 'link', rel: 'canonical', href: canonicalLink }]
    : [];

  return [
    ...titleAttributes,
    ...descriptionAttributes,
    ...defaults,
    ...noIndex,
    ...canonicalLinkAttribute,
    { name: 'theme-color', content: themeColor },
  ];
};
